import { render, staticRenderFns } from "./MyLevels.vue?vue&type=template&id=e6f5d2b2&"
import script from "./MyLevels.vue?vue&type=script&lang=js&"
export * from "./MyLevels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports